<script setup lang="ts">
import model from '@/ts/model.ts';
import Flag from '../flag.vue';
import CaretDownIcon from '@/assets/icons/caret-down-icon.svg?raw';
import vClickOutside from '@/ts/directives/v-click-outside.ts';
import { ref } from 'vue';
import type { SupportedLang } from '@/ts/types/lang-label-types.ts';
import { updateLang } from '@/ts/management/user-management.ts';
import { getLangText } from '@/ts/utils/model-utils';
const itemsDisplayed = ref<boolean>(false);
function onSelectLang(item: SupportedLang){
    updateLang(item.lang, false);
    itemsDisplayed.value = false;
}
</script>

<template>
    <template v-if="model.supportedLangs.length > 0">
        <div class="lang-selector" v-click-outside="() => itemsDisplayed = false" v-mobile>
            <div class="btn" @click.prevent="itemsDisplayed = !itemsDisplayed" v-mobile>
                <flag :flag="model.flagValue" :size="24" />
                <template v-if="model.isMobile">
                    <span class="name">{{ getLangText(model.langLabel) }}</span>
                </template>
                <div class="caret" v-html="CaretDownIcon"></div>
            </div>
            <div class="list" :class="{'displayed': itemsDisplayed}" v-mobile>
                <template v-for="item in model.supportedLangs">
                    <div class="item" :class="{active: model.flagValue == item.flagValue}" @click.prevent="onSelectLang(item)">
                        <flag :flag="item.flagValue" :size="24" />
                        <span class="name">{{ getLangText(item.langLabel) }}</span>
                    </div>
                </template>
            </div>
        </div>
    </template>
</template>

<style lang="scss" scoped>
    @use '@/scss/shared';
    .lang-selector{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        &[data-mobile]{
            justify-content: flex-start;
        }
        & > .list{
            position: absolute;
            top:calc(100% + 15px);
            right:0;
            z-index: 5;
            border-radius: 5px;
            overflow: hidden;
            opacity: 0;
            pointer-events: none;
            transition: opacity .25s;
            &[data-mobile]{
                right: auto;
                left: 0;
                width: 100%;
            }
            &.displayed{
                opacity: 1;
                pointer-events: all;
            }
            @include shared.site() using($site-key){
                border: 2px solid shared.theme-color('comp3_3', $site-key);
            }
            & > .item{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 5px 12px 5px 10px;
                transition: background-color .25s;
                @include shared.site() using($site-key){
                    background-color: shared.theme-color('comp2_7', $site-key);
                }
                &.active,
                &:hover{
                    cursor: pointer;
                    @include shared.site() using($site-key){
                        background-color: shared.theme-color('comp2_5', $site-key);
                    }
                }
                & > .name{
                    padding-left: 5px;
                    font-size: 13px;
                    font-weight: 600;
                }
            }
        }
        & > .btn{
            cursor: pointer;
            transition: filter .25s, transform .25s;
            &:not([data-mobile]){
                padding: 0 10px;
                filter: drop-shadow(0 0 5px #ffffff8f);
                &:hover{
                    filter: drop-shadow(0 0 10px #ffffffce);
                }
            }
            &[data-mobile]{
                width: 100%;
                justify-content: flex-start;
            }
            & > .name{
                font-weight: 600;
                padding-left: 5px;
            }
            &,
            & > .caret{
                display: flex;
                justify-content: center;
                align-items: center;
            }
            & > .caret{
                color: #fff;
            }
        }
    }
</style>